import React from 'react';
import { Search, Globe, Bell } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { Input } from './ui/input';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function TopBar() {
  const { t, lang, setLang, user } = useApp();
  return (
    <div className="sticky top-0 z-30 backdrop-blur bg-[#0a0a0b]/80 border-b border-white/5">
      <div className="flex items-center gap-3 px-4 lg:px-8 h-14">
        <div className="lg:hidden"><Link to="/"><Logo withText={false} /></Link></div>
        <div className="flex-1 max-w-xl relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input placeholder={t('nav.search')} className="pl-9 bg-[#141416] border-white/10 text-sm h-10 focus-visible:ring-pink-500/40" />
        </div>
        <div className="flex items-center gap-2">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className="text-zinc-300 hover:text-white hover:bg-white/5 gap-2">
                <Globe size={16} /> {lang.toUpperCase()}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[#141416] border-white/10 text-zinc-200">
              <DropdownMenuItem onClick={() => setLang('fr')}>Français</DropdownMenuItem>
              <DropdownMenuItem onClick={() => setLang('en')}>English</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Button variant="ghost" size="icon" className="text-zinc-300 hover:text-white hover:bg-white/5"><Bell size={18} /></Button>
          {!user && (
            <Link to="/auth?mode=signin" className="hidden md:inline-block"><Button className="bg-white text-black hover:bg-zinc-200 h-9">{t('nav.signin')}</Button></Link>
          )}
        </div>
      </div>
    </div>
  );
}
